import { SuperSchema } from '@updater/ui-informant';
import { INTERNET_USAGE_QUESTION, toOneOf } from '@updater/ui-widgets';

export const internetUsageMerchandisingSchema: SuperSchema = {
  type: 'object',
  properties: {
    internetUsage: {
      type: 'array',
      minItems: 1,
      items: {
        type: 'string',
        oneOf: toOneOf(INTERNET_USAGE_QUESTION),
      },
      ui: { component: 'checkPillMultiList' },
      required: ['oneOf'],
    },
  },
  required: ['internetUsage'],
};
